'use strict';

module.exports = function() {
	var i, j;
	var currentColors = [];

	for (i = 0; i < this.currentColors.length; i++) {
		currentColors.push([]);
		for (j = 0; j < 3; j++) {currentColors[i].push(this.currentColors[i][j])}
	}

	// Return a deep copy of the current colors
	return currentColors;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/getCurrentColors.js
// module id = 36
// module chunks = 0